import React, { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import { FormInput, FormSwitch, FormTextArea, FormNumericTextBox, FormDropDownList, FormDatePicker, FormAddress } from "../components/formComponents";
import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn as Column, GridToolbar} from '@progress/kendo-react-grid';
import { Label, Error } from '@progress/kendo-react-labels';
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import { processMultiSelectTreeData, expandedState  } from "../components/multiselecttree-data-operations";
import { MultiSelectTreeEditor } from "../components/MultiSelectTreeEditor";
import { DatePickerPropsContext } from '@progress/kendo-react-dateinputs';
import $ from "jquery"
import { TextBox } from '@progress/kendo-react-inputs';
import { GetPermissions } from '../components/Options';
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { Map, MapLayers, MapTileLayer, MapMarkerLayer } from '@progress/kendo-react-map';
import { Dialog } from "@progress/kendo-react-dialogs";
import ExpansionPanel from "../components/ExpansionPanel";

export const FormGridEditContext = React.createContext({});

const ActionCell = (props) => {
    const {dataItem} = props;
    return (
        <td>
          <Button icon="delete" onClick={() => props.remove(dataItem)} title="Delete" />
          <Button icon="save" onClick={() => props.save()} title="Save" />
        </td>
      )
}

const FormGrid = fieldArrayRenderProps => {
    const jobId = fieldArrayRenderProps.jobId;
    const [filter, setFilter] = React.useState([]);
    const data = fieldArrayRenderProps.productList;
    const [changes, setChanges] = React.useState(false);
    const [edit, setEdit] = React.useState({});
    const UpdateGrid = fieldArrayRenderProps.update;

    const datePickerProps = React.useCallback( // fix date format for filter and edit in grid
        (datePickerProps) => ({...datePickerProps, format: 'dd/MM/yy',  }), []
    );

    const CommandCell = (props) => {
        return (
            <ActionCell {...props} remove={Remove} save={Save} />
        )
    }

    const handleEditChange = event => {
        setEdit(event.edit);
    }

    const itemChange = event => {
        UpdatePrice(event.dataItem, event.field, event.value);
        setChanges(true);
    }

    const UpdatePrice = (item, field, value) => {
        var url = `${configData.SERVER_URL}apiv7/jobproductprices`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "jobId": jobId,
                "productId": item.Id,
                "price": field === "Price" ? value : (item.Price === "Free" ? -1 : (item.Price === "Standard" ? 0 : item.Price)),
                "tonnesOrdered": field === "Ordered" ? value: item.Ordered,
                "SchedulePriceDate": field === "SchedDate" ? value.toISOString() : item.SchedDate,
                "price_S": field === "SchedPrice" ? value: (item.SchedPrice === "Free" ? -1 :(item.SchedPrice === "Standard" ? 0 : item.SchedPrice))
            })
        }
        fetch(url, init).then(response => response).then(d => {
            UpdateGrid();
        });
    }

    const Save = () => {
        UpdateGrid();
    }

    const Remove = (item) => {
        if (fieldArrayRenderProps.onChange) fieldArrayRenderProps.onChange.call(undefined, { value: item });
        var url = `${configData.SERVER_URL}apiv7/jobproductprices/${item.JppId}`;
        const init = {
            method: 'DELETE',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init).then(response => response).then(d => {
           UpdateGrid();
        });
    }

    return <DatePickerPropsContext.Provider value={datePickerProps}><Grid style={{ height: '420px' }} data={data} dataItemKey={"Id"} rowHeight={50} edit={edit} editable={{ mode: 'incell' }} onEditChange={handleEditChange} onItemChange={itemChange}
        pageable={{ buttonCount: 4, pageSizes: [10, 20, 50, 100, 200, "All"] }}    >
        <Column field="Name" title="Product" editable={false} />
        <Column field="Price" title="Price $" format="{0:c}" editor="numeric" filter="numeric" />
        <Column field="Ordered" title="Tonnes Ordered" format="{0:n2}" editor="numeric" filter="numeric" />
        <Column field="Processed" title="Tonnes Processed" format="{0:n2}" filter="numeric" editable={false} />
        <Column field="SchedDate" title="Scheduled Date" format="{0:d/MM/yy}" editor="date" filter="date" />
        <Column field="SchedPrice" title="Scheduled Price $" format="{0:c}" filter="numeric" editor="numeric" />
        <Column field="Action" title="Delete" cells={{ data: CommandCell }} editable={false} />
    </Grid> </DatePickerPropsContext.Provider>;
};
  
const EditJobs = () => {
    const { id } = useParams(); // editjobs/id url is used to edit existing job, otherwise id is undefined
    const saveName = id === undefined ? "Create" : "Update";
    const [formkey, setFormkey] = React.useState(0); // seems to be needed to push values to form after loading
    const [customers, setCustomers] = React.useState([]);
    const [customer, setCustomer] = React.useState("");
    const [customerOpen, setCustomerOpen] = React.useState(false);
    const [states, setStates] = React.useState([ ]);
    const [products, setProducts] = React.useState([]);
    const [product, setProduct] = React.useState("");
    const [productOpen, setProductOpen] = React.useState(false);
    const [addProducts, setAddProducts] = React.useState([]);
    const [addProduct, setAddProduct] = React.useState("");
    const [addProductOpen, setAddProductOpen] = React.useState(false);
    const [jpp, setJpp] = React.useState([]);
    const [permissions, setPermissions] = React.useState(null);
    const allOptions = React.useRef();
    const [centre, setCentre] = React.useState([-33.8, 151]);
    const tileUrl = e => `https://${e.subdomain}.tile.openstreetmap.org/${e.zoom}/${e.x}/${e.y}.png`;
    const [markers, setMarkers] = React.useState([]);
    const [zoom, setZoom] = React.useState(12);
    const [showMap, setShowMap] = React.useState(false);
    const [submitDisabled, setSubmitDisabled] = React.useState(false);
    const fv = React.useRef(null); 
    const [expandedPanels, setExpandedPanels] = useState({
        jobDetails: true,
        chargeDetails: false,
        addressDetails: false,
        deliveryDetails: false,
        linkedData: true,
        productId: false
    });
    const addFreeValues = [ "Standard Price", "Override Price", "Free" ];
    
    const togglePanel = (panel) => {
        setExpandedPanels(prev => ({ ...prev, [panel]: !prev[panel] }));
    };

    const navigate = useNavigate();
    // default layout data for page
    const [layout, setLayout] = React.useState([
        { "field": "jobId", "label": "ID", "defaultValue": "", "isVisible": false, "type": "numeric" },
        { "field": "name", "label": "Name", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "code", "label": "Code", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "customerId", "label": "Customer", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "productId", "label": "Product", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "linkedProducts", "label": "Linked Products", "defaultValue": "", "isVisible": true, "type": "table" },
        { "field": "orderNumber", "label": "Order Number", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "destinationId", "label": "Destination", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "linkedDestinations", "label": "Linked Destinations", "defaultValue": "", "isVisible": true, "type": "table" },
        { "field": "sourceId", "label": "Source", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "linkedSources", "label": "Linked Sources", "defaultValue": "", "isVisible": true, "type": "table" },
        { "field": "description", "label": "Comment", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "department", "label": "Department", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "workOrderSystemCode", "label": "Work Order System Code", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "docketShouldBeSigned", "label": "Dockets must be signed", "defaultValue": "false", "isVisible": true, "type": "boolean" },
        { "field": "jobTonnesOrdered", "label": "Job Tonnes Ordered (t)", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "jobTonnesRunningTotal", "label": "Job Tonnage Running Total (t)", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "chargeDetails", "label": "Charge details", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "cartageCostPerTonne", "label": "Cartage Cost $/t", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "minimumCartage", "label": "Cartage Minimum $", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "overloadFee", "label": "Overload Charge $/t", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "cartagePerTonne", "label": "Cartage Charge $/t", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "addressDetails", "label": "Address details", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "jobAddress1", "label": "Job Address 1", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobAddress2", "label": "Job Address 2", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobSuburb", "label": "Job Suburb", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobState", "label": "Job State", "defaultValue": "NSW", "isVisible": true, "type": "list" },
        { "field": "jobPostcode", "label": "Job Postcode", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobZone", "label": "Job Zone", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobPhone", "label": "Job Phone", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobEmail", "label": "Job Email", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobTrucks", "label": "Trucks", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "addProduct", "label": "Product", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "addPrice", "label": "Price $", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "addTonnesOrdered", "label": "Tonnes Ordered", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "jobDetails", "label": "Job", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "siteDetails", "label": "Site details", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "linkedData", "label": "Relationships", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "activeFrom", "label": "Active From", "defaultValue": undefined, "isVisible": true, "type": "datetime" },
        { "field": "activeTo", "label": "Active Until", "defaultValue": undefined, "isVisible": true, "type": "datetime" },
        { "field": "active", "label": "Active", "defaultValue": true, "isVisible": true, "type": "boolean"},
        { "field": "addFree", "label": "Price", "defaultValue": "Standard Price", "isVisible": true, "type": "list" }
    ]);
    if (localStorage.getItem("userid") === null) navigate("/logout");

    // Gets field from layout based on field name
    const GetField = (f, def = "") => {
        let fld = layout.find(obj => { return obj.field === f });
        if (fld === undefined) return { "field": f, "label": def, "defaultValue": "", "isVisible": true, "type": "text" }
        return fld;
    }

    // State data for form. Values match form value on submit
    const [values, setValues] = React.useState({
        jobId: GetField("jobId")["defaultValue"],
        name: GetField("name")["defaultValue"],
        code: GetField("code")["defaultValue"],
        customerId: GetField("customerId")["defaultValue"],
        productId: GetField("productId")["defaultValue"],
        linkedProducts: GetField("linkedProducts")["defaultValue"],
        orderNumber: GetField("orderNumber")["defaultValue"],
        destinationId: [],
        linkedDestinations: GetField("linkedDestinations")["defaultValue"],
        sourceId: [],
        linkedSources: GetField("linkedSources")["defaultValue"],
        description: GetField("description")["defaultValue"],
        department: GetField("department")["defaultValue"],
        workOrderSystemCode: GetField("workOrderSystemCode")["defaultValue"],
        docketShouldBeSigned: GetField("docketShouldBeSigned")["defaultValue"].toLowerCase() === "true",
        jobTonnesOrdered: GetField("jobTonnesOrdered")["defaultValue"],
        jobTonnesRunningTotal: GetField("jobTonnesRunningTotal")["defaultValue"],
        chargeDetails: GetField("chargeDetails")["defaultValue"],
        cartageCostPerTonne: GetField("cartageCostPerTonne")["defaultValue"],
        minimumCartage: GetField("minimumCartage")["defaultValue"],
        overloadFee: GetField("overloadFee")["defaultValue"],
        cartagePerTonne: GetField("cartagePerTonne")["defaultValue"],
        addressDetails: GetField("addressDetails")["defaultValue"],
        jobAddress1: GetField("jobAddress1")["defaultValue"],
        jobAddress2: GetField("jobAddress2")["defaultValue"],
        jobSuburb: GetField("jobSuburb")["defaultValue"],
        jobState: GetField("jobState")["defaultValue"],
        jobPostcode: GetField("jobPostcode")["defaultValue"],
        jobZone: GetField("jobZone")["defaultValue"],
        jobPhone: GetField("jobPhone")["defaultValue"],
        jobEmail: GetField("jobEmail")["defaultValue"],
        jobTrucks: [],
        jobSites: [],
        addProduct: [],
        addPrice: GetField("addProduct")["defaultValue"],
        addTonnesOrdered: GetField("addTonnesOrdered")["defaultValue"],
        siteDetails: GetField("siteDetails")["defaultValue"],        
        active: String(GetField("active")["defaultValue"]).toLowerCase() === "true",
        activeFrom: GetField("activeFrom")["defaultValue"],
        activeTo: GetField("activeTo")["defaultValue"],
        addFree: false
      });

    // When page first loads:
    // - populate drop downs from apiv7/options
    // - if in edit mode, set initial values for all fields for apiv7/vehicleconfigurations
    React.useEffect(() => {
        GetPermissions(["ViewJob", "NewJob", "EditJob"], setPermissions);
        var url = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'EditJobs'";
        const init = {
          method: 'GET',
          accept: 'application/json',
          headers: {"Authorization": "Bearer " + GetToken()}
        }
        fetch(url, init).then(response => response.json()).then(d => { 
            if (GetSession().IsMobile){
                let data = [];
                for(let i = 0; i < d.length; i++){
                    data.push({field: d[i].field, label: d[i].label, type:d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile});
                }
                setLayout(data);
            } else {
                setLayout(d); 
            }
        });
        url = configData.SERVER_URL + "apiv7/options";
        fetch(url, init).then(response => response.json()).then(opt => {           
            allOptions.current = opt;
            setStates(opt.states);
            let cu = opt.customers.map(obj => { return obj.name; });
            setCustomers(cu);
            let pr = opt.products.map(obj => { return obj.name; });
            setProducts(pr);
            setAddProducts(pr);
            let defSrc = ConfigureSources(opt.sources, opt.inactiveSources, "1");
            let defDest = ConfigureDestinations(opt.destinations, opt.inactiveDestinations, "1");
            let allSites = GetList(opt.sites);
            let defSites = ConfigureSites(opt.sites, opt.inactiveSites, allSites);
            ConfigureTrucks(opt.trucks, opt.inactiveTrucks, "");
            if (id !== undefined){
                url = `${configData.SERVER_URL}apiv7/jobs/${id}`;
                fetch(url, init).then(response => response.json()).then(d => {
                    var cust = opt.customers.find(obj => { return obj.id === String(d.customerId) });
                    let dest = ConfigureDestinations(opt.destinations, opt.inactiveDestinations, d.destinationList);
                    let src = ConfigureSources(opt.sources, opt.inactiveSources, d.sourceList);
                    let sites = ConfigureSites(opt.sites, opt.inactiveSites, d.siteList);
                    let trucks = ConfigureTrucks(opt.trucks, opt.inactiveTrucks, d.truckList);
                    let prods = ConfigureProducts(opt.products, opt.inactiveProducts, d.productList);
                    if (cust !== undefined) setCustomer(cust.name);
                    fv.current = {
                        name: d.name === null ? "" : d.name,
                        code: d.code === null ? "" : d.code,
                        customerId: cust === undefined ? "" : cust.name,
                        productId: prods,
                        orderNumber: d.orderNumber === null ? "" : d.orderNumber,
                        destinationId: dest,
                        sourceId: src,
                        description: d.description === null ? "" : d.description,
                        department: d.department === null ? "" : d.department,
                        workOrderSystemCode: d.workOrderSystemCode === null ? "" : d.workOrderSystemCode,
                        docketShouldBeSigned: d.docketsShouldBeSigned === null ? "" : d.docketsShouldBeSigned,
                        jobTonnesOrdered: d.jobTonnesOrdered === null ? "" : d.jobTonnesOrdered,
                        jobTonnesRunningTotal: d.jobTonnesRunningTotal === null ? "" : d.jobTonnesRunningTotal,
                        chargeDetails: d.chargeDetails === null ? "" : d.chargeDetails,
                        cartageCostPerTonne: d.cartageCostPerTonne === null ? "" : d.cartageCostPerTonne,
                        minimumCartage: d.minimumCartage === null ? "" : d.minimumCartage,
                        overloadFee: d.overloadFee === null ? "" : d.overLoadFee,
                        cartagePerTonne: d.cartagePerTonne === null ? "" : d.cartagePerTonne,
                        jobAddress1: d.jobAddress1 === null ? "" : d.jobAddress1,
                        jobAddress2: d.jobAddress2 === null ? "" : d.jobAddress2,
                        jobSuburb: d.jobSuburb === null ? "" : d.jobSuburb,
                        jobState: d.jobState === null ? "" : d.jobState,
                        jobPostcode: d.jobPostcode === null ? "" : d.jobPostcode,
                        jobZone: d.jobZone === null ? "" : d.jobZone,
                        jobPhone: d.jobPhone === null ? "" : d.jobPhone,
                        jobEmail: d.jobEmail === null ? "" : d.jobEmail,
                        jobSites: sites,
                        jobTrucks: trucks,
                        activeFrom: d.activeFrom === null ? undefined : new Date(d.activeFrom + "Z"),
                        activeTo: d.activeTo === null ? undefined : new Date(d.activeTo + "Z"),
                        active: d.isActive === null ? "" : d.isActive,
                        addFree: "Standard Price"
                    };
                    setValues(fv.current);
                    UpdateJobProductPrices(opt.products, false);
                    setFormkey(formkey + 1);
                })
            } else {
                ConfigureProducts(opt.products, opt.inactiveProducts, "");
                fv.current = { ...values };
                fv.current.jobSites = defSites;
                fv.current.sourceId = defSrc;
                fv.current.destinationId = defDest;
                setValues(fv.current);                
                setFormkey(formkey + 1);
            }
        });
    }, [id]);

    const ConfigureProductPrices = (pp, refresh) => {
        let pl = [];
        let products = allOptions.current.products;
        if (pp !== null) {
            let totalOrdered = 0;
            let totalProcessed = 0;
            for (let i = 0; i < products.length; i++){
                let p = pp.find(obj => { return String(obj.productId) === products[i].id});
                if (p !== undefined){
                    let price = p !== undefined ? p.price : 0;
                    let ordered = p !== undefined ? p.tonnesOrdered: 0;
                    let processed = p !== undefined ? p.tonnesProcessed : 0;
                    totalOrdered += ordered;
                    totalProcessed += processed;
                    let schedDate = p !== undefined && p.schedulePriceDate !== null ? new Date(p.schedulePriceDate) : null;
                    let schedPrice = p !== undefined ? p.price_S: 0;
                    let jppId = p !== undefined ? p.jobProductPriceId: 0;
                    pl.push({
                        Id: products[i].id,
                        Name: products[i].name,
                        Price: price < 0 ? "Free" : (price === 0 ? "Standard" : price),
                        Ordered: ordered,
                        Processed: processed,
                        SchedDate: schedDate,
                        SchedPrice: schedPrice < 0 ? "Free" : (schedPrice === 0 ? "Standard" : schedPrice),
                        JppId: jppId
                    });
                }
            }
            if (refresh  && (totalOrdered !== values.jobTonnesOrdered || totalProcessed !== values.jobTonnesRunningTotal)) {
                fv.current.jobTonnesOrdered = totalOrdered;
                fv.current.jobTonnesRunningTotal = totalProcessed;
                setValues(fv.current);
                setFormkey(new Date());
            }
        }
        jppUpdated(pl);
    }

    // Returns value to be sent to web api:
    // If field is visible just return f
    // If field is hidden, return defaultValue from layout data
    const GetDefaultData = (f, name) => {
        let fld = GetField(name);
        if (f === undefined) f = "";
        if (fld === undefined || fld === null) return f;
        let res = fld["defaultValue"];
        if (fld["isVisible"]) res = f;
        switch(fld["type"]){
            case "numeric": 
                res = parseFloat(res); 
                if (isNaN(res)) res = 0;
                break;
            case "boolean": res = (res === "true" || res === true); break;
            case "date":
                if (res === "") res = null;
                break;
            default: break;
        }
        return res;
    }

    // navigation
    const GoBack = () => Redirect("");
    const AddExtraCharge = () => navigate("/addextracharge/" + id);
    const Redirect = (msg = "") => {
        navigate("/jobs", {state: {msg: msg}});
    }

    if (permissions && !permissions.CanView) navigate("/error401");
    if (permissions && !permissions.CanEdit && id !== undefined) navigate("/error401");
    if (permissions && !permissions.CanCreate && id === undefined) navigate("/error401");

    const [sourcesData, setSourcesData] = React.useState([{id:0, text: "Active", items: []}]);
    const dataItemKey = "id";
    const checkField = "checkField";
    const checkIndeterminateField = "checkIndeterminateField";
    const subItemsField = "items";
    const expandField = "expanded";
    const fields = { dataItemKey, checkField, checkIndeterminateField, expandField, subItemsField };
    // state data for source multi-select tree   
    const [sourcesValue, setSourcesValue] = React.useState([]);
    const [sourceExpanded, setSourceExpanded] = React.useState([]);
    const onSourcesChange = (event) => {
        setSourcesValue(getMultiSelectTreeValue(sourcesData, {...fields, ...event, value: sourcesValue, }));
    }
    const sourcesTreeData = React.useMemo(() => processMultiSelectTreeData(sourcesData, { expanded: sourceExpanded, value: sourcesValue, ...fields }), [sourceExpanded, sourcesValue]);
    const ConfigureSources = (act, dis, sourceList) => {
        if (sourceList === null || sourceList === undefined) return [];
        let slsp = sourceList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = {id: 999999, text: 'Inactive', items: sl };
            setSourcesData([active, inactive]);
        }
        else {
            setSourcesData([active]);
        }
        setSourcesValue([...selected]);       
        return [...selected];
    }

    // state data for destinations multi-select tree 
    const [destData, setDestData] = React.useState([{id:0, text: "Active", items: []}]);
    const [destValue, setDestValue] = React.useState([]);
    const [destExpanded, setDestExpanded] = React.useState([]);
    const destTreeData = React.useMemo(() => processMultiSelectTreeData(destData, { expanded: destExpanded, value:destValue, ...fields }), [destExpanded, destValue]);
    const ConfigureDestinations = (act, dis, destList) => {
        if (destList === null || destList === undefined) return [];
        let destsp = destList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = destsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: [...sl] };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = destsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
                }
            let inactive = {id: 999999, text: 'Inactive', items: [...sl] };
            setDestData([active, inactive]);
        }
        else {
            setDestData([active]);
        }
        setDestValue([...selected]);
        return [...selected];
    }

    const [sitesData, setSitesData] = React.useState([{id:0, text: "Active", items: []}]);
    const [sitesValue, setSitesValue] = React.useState([]);
    const [siteExpanded, setSiteExpanded] = React.useState([]);
    const sitesTreeData = React.useMemo(() => processMultiSelectTreeData(sitesData, { expanded: siteExpanded, value: sitesValue, ...fields }), [siteExpanded, sitesValue]);
    const ConfigureSites = (act, dis, siteList) => {
        if (siteList === null || siteList === undefined) return [];
        let slsp = siteList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = {id: 999999, text: 'Inactive', items: sl };
            setSitesData([active, inactive]);
        }
        else {
            setSitesData([active]);
        }
        setSitesValue([...selected]);       
        return [...selected];
    }

    const [trucksData, setTrucksData] = React.useState([{id:0, text: "Active", items: []}]);
    const [trucksValue, setTrucksValue] = React.useState([]);
    const [truckExpanded, setTruckExpanded] = React.useState([]);
    const trucksTreeData = React.useMemo(() => processMultiSelectTreeData(trucksData, { expanded: truckExpanded, value: trucksValue, ...fields }), [truckExpanded, trucksValue]);
    const ConfigureTrucks = (act, dis, truckList) => {
        if (truckList === null ||  truckList === undefined) return [];
        let slsp = truckList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = {id: 999999, text: 'Inactive', items: sl };
            setTrucksData([active, inactive]);
        }
        else {
            setTrucksData([active]);
        }
        setTrucksValue([...selected]);       
        return [...selected];
    }

    const [prodsData, setProdsData] = React.useState([{ id: 0, text: "Active", items: [] }]);
    const [prodsValue, setProdsValue] = React.useState([]);
    const [prodExpanded, setProdExpanded] = React.useState([]);
    const prodsTreeData = React.useMemo(() => processMultiSelectTreeData(prodsData, { expanded: prodExpanded, value: prodsValue, ...fields }), [prodExpanded, prodsValue]);
    const ConfigureProducts = (act, dis, prodList) => {
        if (prodList === null || prodList === undefined) prodList = "";
        let slsp = prodList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++) {
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = { id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0) {
            sl = [];
            for (let i = 0; i < dis.length; i++) {
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = { id: 999999, text: 'Inactive', items: sl };
            setProdsData([active, inactive]);
        }
        else {
            setProdsData([active]);
        }
        setProdsValue([...selected]);
        return [...selected];
    }


    const GetList = (obj) => {
        if (obj === undefined || obj === null || obj.length === 0) return "";
        var l = "";
        for (let i = 0; i < obj.length; i++){
            let id = obj[i].id;
            if (id !== 0 && id !== 999990){
                l += id;
                if (i < obj.length - 1) l += ",";
            }
        }
        return l;
    }

    function UpdatePrices(){  
        UpdateJobProductPrices(products, true);
    }

    const UpdateJobProductPrices = (products, refresh) => {
        let url = configData.SERVER_URL + "apiv7/jobproductprices?$filter=jobId eq " + id;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: {"Authorization": "Bearer " + GetToken()}
          }
          fetch(url, init).then(response => response.json()).then(pp => {           
            ConfigureProductPrices(pp, refresh);
        });
    }

    const jppUpdated = (newData) => {
        setJpp(newData);
        var pl = "";
        for (var i = 0; i < newData.length; i++) {
            pl += newData[i].Id;
            if (i < newData.length - 1) pl += ",";
        }
        let prods = ConfigureProducts(allOptions.current.products, allOptions.current.inactiveProducts, pl);
        fv.current.productId = prods;
        setValues(fv.current);
        setFormkey(formkey + 1);
    };

    const ProductsChanged = (e) => {
        fv.current.productId = e.value;
        setValues(fv.current);
        let j = [...jpp];
        if (e.value === null) {
            j = [];
            setJpp(j);
            return;
        }
        if (j.length > e.value.length) {
            // product has been removed from multi-select. Remove it from grid
            for (var i = 0; i < j.length; i++) {
                let x = e.value.find(obj => obj.id === j[i].Id);
                if (x === undefined || x === null) {
                    j.splice(i, 1);
                    i = jpp.length;
                }
            }
        } else {
            if (jpp.length < e.value.length) {
                // product(s) added to multi-select. Add to grid
                var ind = 0;
                for (var i = 0; i < e.value.length; i++) {
                    let x = j.find(obj => obj.Id === e.value[i].id);
                    if (x === undefined) {
                        j.push({ Id: e.value[i].id, Name: e.value[i].text, Price: "Standard", Ordered: 0, Processed: 0, SchedDate: null, SchedPrice: "Standard", JppId: 0 });
                    }
                }
            }
        }
        setJpp(j);
    }


    const addProductClicked = (e) => {
        e.preventDefault();       
        if (addProduct === undefined || addProduct === "") {
            alert("Select a product");
            return;
        }
        let p = allOptions.current.products.find(obj => obj.name === addProduct);
        let pr = 0;
        switch (fv.current.addFree) {
            case "Standard Price": pr = 0; break;
            case "Override Price": pr = parseFloat($("#addPrice").val().replace("$", "")); break;
            case "Free": pr = -1; break;
        }
        if (isNaN(pr)) pr = 0;
        let ton = parseFloat($("#addTonnesOrdered").val());
        if ((isNaN(ton))) ton = 0;
        var url = `${configData.SERVER_URL}apiv7/jobproductprices`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "jobId": id,
                "productId": p.id,
                "price" : pr,
                "tonnesOrdered": ton
            })
        }
        fetch(url, init).then(response => response).then(d => { 
            UpdatePrices();
        });
    }

    const Validate = (dataItem) => {
        let st = "";
        if (dataItem.name === undefined || dataItem.name === '') {
            st += "Name\r\n";
        } else {
            let t = allOptions.current.jobs.find(obj => obj.name === dataItem.name && obj.id !== id);
            if (t !== undefined) st += dataItem.name + " job name already exists.\r\n";
        }
        if (dataItem.code === undefined || dataItem.code ==='') st += "Code\r\n";
        if (customer === undefined || customer ==='') st += "Customer\r\n";
        if (st !== "") {
            setExpandedPanels({ jobDetails: true, chargeDetails: false, addressDetails: false, deliveryDetails: false, linkedData: false, productId: false });
            alert("Please enter the following: \r\n" + st);
            return false;
        }
        return true;
    }

    // Handle submit button. For create POST the data, for edit PUT the data, then redirect to offenses index page.
    const handleSubmit = () => {
        let dataItem = { ...values };
        if (!Validate(dataItem)) return;  
        var cust = allOptions.current.customers.find(obj => obj.name === customer);
        if (cust === undefined) {
            setExpandedPanels({ jobDetails: true, chargeDetails: false, addressDetails: false, deliveryDetails: false, linkedData: false, productId: false });
            alert("Please enter customer");
            return;
        }
        var prod = allOptions.current.products.find(obj => obj.name === product);
        if (prod === undefined) prod = { id: "1" };
        var pth = id === undefined ? "" : "/" + id;
        var siteList = GetList(dataItem.jobSites);
        var destList = GetList(dataItem.destinationId);
        var srcList = GetList(dataItem.sourceId);        
        var truckList = GetList(dataItem.jobTrucks);;
        var productId = 0;
        var jppList = [];
        for (let i = 0; i < jpp.length; i++){
            if (productId === 0) productId = parseInt(jpp[i].Id);
            let pr = 0;
            if (jpp[i].Price === "Free") {
                pr = -1;
            } else if (jpp[i].Price !== "Standard") {
                pr = jpp[i].Price;
            }
            let sp = 0;
            if (jpp[i].SchedPrice === "Free") {
                sp = -1;
            } else if (jpp[i].SchedPrice !== "Standard") {
                sp = jpp[i].SchedPrice;
            }
           jppList.push({jobId: id, productId: jpp[i].Id, price: pr, price_S: sp, tonnesOrdered:jpp[i].Ordered, schedulePriceDate:jpp[i].SchedDate });
        }
        var activeFrom = (dataItem.activeFrom === "" || dataItem.activeFrom === undefined) ? null : dataItem.activeFrom.toISOString();
        var activeTo = (dataItem.activeTo === "" || dataItem.activeTo === undefined) ? null : dataItem.activeTo.toISOString();
        setSubmitDisabled(true);
        //Price: price, Ordered: ordered, Processed: processed, SchedDate: schedDate, SchedPrice: schedPrice 
        var url = `${configData.SERVER_URL}apiv7/jobs${pth}`;
        const init = {
            method: id === undefined ? 'POST' : 'PUT',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
            "jobId": id === undefined ? 0 : id,
            "name": GetDefaultData(dataItem.name, "name"),
            "code": GetDefaultData(dataItem.code, "code"),
            "customerId": GetDefaultData(cust.id, "customerId"),
            "productId": productId,
            "orderNumber": GetDefaultData(dataItem.orderNumber, "orderNumber"),
            "description": GetDefaultData(dataItem.description, "description"),
            "department": GetDefaultData(dataItem.department, "department"),
            "workOrderSystemCode": GetDefaultData(dataItem.workOrderSystemCode, "workOrderSystemCode"),
            "docketsShouldBeSigned": GetDefaultData(dataItem.docketShouldBeSigned, "docketShouldBeSigned"),
            "jobTonnesOrdered": GetDefaultData(dataItem.jobTonnesOrdered, "jobTonnesOrdered"),
            "jobTonnesRunningTotal": GetDefaultData(dataItem.jobTonnesRunningTotal, "jobTonnesRunningTotal"),
            "chargeDetails": GetDefaultData(dataItem.chargeDetails, "chargeDetails"),
            "cartageCostPerTonne": GetDefaultData(dataItem.cartageCostPerTonne, "cartageCostPerTonne"),
            "minimumCartage": GetDefaultData(dataItem.minimumCartage, "minimumCartage"),
            "overloadFee": GetDefaultData(dataItem.overloadFee, "overloadFee"),
            "cartagePerTonne": GetDefaultData(dataItem.cartagePerTonne, "cartagePerTonne"),
            "jobAddress1": GetDefaultData(dataItem.jobAddress1, "jobAddress1"),
            "jobAddress2": GetDefaultData(dataItem.jobAddress2, "jobAddress2"),
            "jobSuburb": GetDefaultData(dataItem.jobSuburb, "jobSuburb"),
            "jobState": GetDefaultData(dataItem.jobState, "jobState"),
            "jobPostcode": GetDefaultData(dataItem.jobPostcode, "jobPostcode"),
            "jobZone": GetDefaultData(dataItem.jobZone, "jobZone"),
            "jobPhone": GetDefaultData(dataItem.jobPhone, "jobPhone"),
            "jobEmail": GetDefaultData(dataItem.jobEmail, "jobEmail"),
            "jobTrucks": GetDefaultData(dataItem.jobTrucks, "jobTrucks"),
            "siteList": siteList,
            "truckList": truckList,
            "sourceList": srcList,
            "destinationList": destList,
            "jobProductPrices": jppList,
            "activeFrom": activeFrom,
            "activeTo": activeTo,
            "isActive": GetDefaultData(dataItem.active, "active") 
            })
        }
        fetch(url, init).then(response => {
            if (response.status === 200) return response.json();
            if (response.status < 300) return "Job updated";
            return `Error ${response.status} updating job`;
        }).then(d => {
            if (id === undefined && d.jobId !== undefined) {
                navigate(`/editjobs/${d.jobId}`, { state: { msg: "Job created" } });
            } else {
                Redirect(d);
            }
        });
    }   

    const CustomerChanged = (e) => {
        LookupCustomer(e.value);
        if (e.value === "") setCustomerOpen(true);
    }

    const LookupCustomer = (cust) => {
        setCustomer(cust);
        let c = cust.toLowerCase();
        let cu = [];
        allOptions.current.customers.map(obj => {
            if (c === "" || String(obj.name).toLowerCase().indexOf(c) >= 0) cu.push(obj.name);
            return null;
        });
        setCustomers(cu);
        let ci = allOptions.current.customers.find(obj => obj.name.toLowerCase() === c);
        if (ci !== undefined) {
            setCustomerOpen(false);
            fv.current.customerId = ci.id;
            setValues(fv.current); 
        }
    }

    const LookupProduct = (prod) => {
        setProduct(prod);
        let p = prod.toLowerCase();
        let pr = [];
        allOptions.current.products.map(obj => {
            if (p === "" || String(obj.name).toLowerCase().indexOf(p) >= 0) pr.push(obj.name);
            return null;
        });
        setProducts(pr);
        let pi = allOptions.current.products.find(obj => obj.name.toLowerCase() === p);
        if (pi !== undefined) {
            setProductOpen(false);
            fv.current.productId = pi.id;
            setValues(fv.current); 
        }
    }

    const AddProductChanged = (e) => {
        LookupAddProduct(e.value);
        if (e.value === "") setAddProductOpen(true);
    }

    const LookupAddProduct = (ap) => {
        setAddProduct(ap);
        let pr = [];
        allOptions.current.products.map(obj => {
            if (ap === "" || String(obj.name).toLowerCase().indexOf(ap) >= 0) pr.push(obj.name);
            return null;
        });
        setAddProducts(pr);
        let p = allOptions.current.products.find(obj => obj.name === ap);
        if (p !== undefined) {
            setAddProductOpen(false);
            let sp = p.data.split(',');
            if (sp.length > 2) {
                fv.current.addPrice = parseFloat(sp[2]);
                fv.current.addProduct = pr;
                setAddProductOpen(false);
                setValues(fv.current);
                setFormkey(formkey + 1);
            }
        }
    }
    const OpenCustomer = () => {
        LookupCustomer("");
        setCustomerOpen(true);
    }
    const OpenProduct = () => {
        LookupProduct("");
        setProductOpen(true);
    }
    const OpenAddProduct = () => {
        LookupAddProduct("");
        setAddProductOpen(true);
    }

    const AddressChanged = (e) => {
        if (e !== null && e.value !== undefined && e.value.terms !== undefined && e.value.terms.length > 2) {
            fv.current.jobAddress1 = e.value.structured_formatting.main_text;
            fv.current.jobAddress2 = "";
            var ind = 1;
            if (e.value.terms.length > 3) ind = e.value.terms.length - 2;
            fv.current.jobSuburb = e.value.terms[ind++].value;
            fv.current.jobState = e.value.terms[ind].value;
            setValues(fv.current);
            setFormkey(new Date());
        }
    }

    const DisplayMap = (e) => {
        let addr = values.jobAddress1;
        if (!values.jobAddress2 !== "") addr += "+" + values.jobAddress2;
        if (!values.jobSuburb !== "") addr += "+" + values.jobSuburb;
        if (!values.jobState !== "") addr += "+" + values.jobState;
        if (!values.jobPostcode !== "") addr += "+" + values.jobPostcode;
        addr += "+AU";
        let a = encodeURIComponent(addr);
        var url = `${configData.SERVER_URL}apiv7/private/getlocation?address=${a}`;
        const init = {
            method: 'GET',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init).then(response => response.json()).then(l => {
            let m = [];
            setCentre([l.latitude, l.longitude]);
            m.push({ position: [l.latitude, l.longitude], name: values.address1 });
            setMarkers(m);
            setShowMap(true);
            setFormkey(formkey + 1);
        });
    }

    // This is annoying and should be unnecessary but Kendo really screws up the submit behaviour.
    // If JS changes anything and the form refreshes the isModified is lost. Easier just to maintain the data manually.
    const NameChanged = (e) => { fv.current.name = e.value; setValues(fv.current); }
    const CodeChanged = (e) => { fv.current.code = e.value; setValues(fv.current); }
    const ActiveChanged = (e) => { fv.current.active = e.value; setValues(fv.current); }
    const OrderNumberChanged = (e) => { fv.current.orderNumber = e.value; setValues(fv.current); }
    const DepartmentChanged = (e) => { fv.current.department = e.value; setValues(fv.current); }
    const WorkOrderSystemCodeChanged = (e) => { fv.current.workOrderSystemCode = e.value; setValues(fv.current); }
    const DescriptionChanged = (e) => { fv.current.description = e.value; setValues(fv.current); }
    const ActiveFromChanged = (e) => { fv.current.activeFrom = e.value; setValues(fv.current); }
    const ActiveToChanged = (e) => { fv.current.activeTo = e.value; setValues(fv.current); }
    const DocketShouldBeSignedChanged = (e) => { fv.current.docketShouldBeSigned = e.value; setValues(fv.current); }
    const CartagePerTonneChanged = (e) => { fv.current.cartagePerTonne = e.value; setValues(fv.current); }
    const MinimumChargeChanged = (e) => { fv.current.minimumCartage = e.value; setValues(fv.current); }
    const CartageCostPerTonneChanged = (e) => { fv.current.cartageCostPerTonne = e.value; setValues(fv.current); }
    const OverloadFeeChanged = (e) => { fv.current.overloadFee = e.value; setValues(fv.current); }
    const JobAddress2Changed = (e) => { fv.current.jobAddress2 = e.value; setValues(fv.current); }
    const JobSuburbChanged = (e) => { fv.current.jobSuburb = e.value; setValues(fv.current); }
    const JobStateChanged = (e) => { fv.current.jobState = e.value; setValues(fv.current); }
    const JobPostcodeChanged = (e) => { fv.current.jobPostcode = e.value; setValues(fv.current); }
    const JobZoneChanged = (e) => { fv.current.jobZone = e.value; setValues(fv.current); }
    const JobPhoneChanged = (e) => { fv.current.jobPhone = e.value; setValues(fv.current); }
    const JobEmailChanged = (e) => { fv.current.jobEmail = e.value; setValues(fv.current); }
    const DestinationsChanged = (e) => { fv.current.destinationId = e.value; setValues(fv.current); }
    const SourcesChanged = (e) => { fv.current.sourceId = e.value; setValues(fv.current); }
    const TrucksChanged = (e) => { fv.current.jobTrucks = e.value; setValues(fv.current); }
    const SitesChanged = (e) => { fv.current.jobSites = e.value; setValues(fv.current); }
    const AddFreeChanged = (e) => { fv.current.addFree = e.value; setValues(fv.current); }   


    // form validators
    const textValidator = (value) =>  !value ? "Please enter a value" : "";
    return (
        <div style={{ padding: 20, maxWidth: 1200, margin: "auto" }}>
           <Form initialValues={values} key={formkey} render={(formRenderProps) => (
               <FormElement style={{width: "95%"}} >
                    <fieldset className={"k-form-fieldset"} style={{ border: "none", padding: 0 }}>
                        {GetField("jobDetails")["isVisible"] && <ExpansionPanel title={GetField("jobDetails")["label"]} expanded={expandedPanels.jobDetails} onToggle={() => togglePanel("jobDetails")}>
                        <div className="row">
                            {GetField("name")["isVisible"] && <div className="col-md-3">
                                <Field id={"name"} name={"name"} label={GetField("name")["label"]} component={FormInput} validator={textValidator} onChange={NameChanged} />
                            </div>}
                            {GetField("code")["isVisible"] && <div className='col-md-3'>
                                <Field id={"code"} name={"code"} label={GetField("code")["label"]} component={FormInput} validator={textValidator} maxLength={40} onChange={CodeChanged} />
                            </div>}                            
                            {GetField("active")["isVisible"] && <div className='col-md-3'>
                                <Field id={"active"} name={"active"} label={GetField("active")["label"]} component={FormSwitch} onChange={ActiveChanged} />
                            </div>}                            
                        </div>
                        <div className="row">
                            {GetField("customerId")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("customerId")["label"]}</Label>
                                    <AutoComplete id={"customerId"} name={"customerId"} data={customers} value={customer} onChange={CustomerChanged} placeholder="Select Customer" opened={customerOpen} onFocus={OpenCustomer} onBlur={() => { setCustomerOpen(false) }} />     
                                </FieldWrapper>
                            </div>}
                            {GetField("productId")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("productId")["label"]}</Label>
                                    <Field component={MultiSelectTreeEditor} name={"productId"} data={prodsTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={ProductsChanged} />                                
                                </FieldWrapper>
                            </div>}
                            {GetField("orderNumber")["isVisible"] && <div className="col-md-3">
                                <Field id={"orderNumber"} name={"orderNumber"} label={GetField("orderNumber")["label"]} component={FormInput} maxLength={40} onChange={OrderNumberChanged} />
                            </div>}
                        </div>
                        <div className='row' >
                            {GetField("department")["isVisible"] && <div className='col-md-3'>
                                <Field id={"department"} name={"department"} label={GetField("department")["label"]} component={FormInput} onChange={DepartmentChanged} />
                            </div>}                            
                            {GetField("workOrderSystemCode")["isVisible"] && <div className='col-md-3'>
                                <Field id={"workOrderSystemCode"} name={"workOrderSystemCode"} label={GetField("workOrderSystemCode")["label"]} component={FormInput} onChange={WorkOrderSystemCodeChanged} />
                            </div>}                            
                            {GetField("description")["isVisible"] && <div className="col-md-3">
                                <Field id={"description"} name={"description"} label={GetField("description")["label"]} component={FormTextArea} onChange={DescriptionChanged} />
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("jobTonnesOrdered")["isVisible"] && <div className="col-md-3">
                                <Field id={"jobTonnesOrdered"} name={"jobTonnesOrdered"} label={GetField("jobTonnesOrdered")["label"]} disabled component={FormInput}/>
                            </div>}
                            {GetField("jobTonnesRunningTotal")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobTonnesRunningTotal"} name={"jobTonnesRunningTotal"} label={GetField("jobTonnesRunningTotal")["label"]} disabled component={FormInput}/>
                            </div>}                            
                            {GetField("docketShouldBeSigned")["isVisible"] && <div className='col-md-3'>
                                <Field id={"docketShouldBeSigned"} name={"docketShouldBeSigned"} label={GetField("docketShouldBeSigned")["label"]} component={FormSwitch} onChange={DocketShouldBeSignedChanged} />
                            </div>}                            
                            {id !== undefined && <div className='col-md-1' style={{paddingTop: 20}}>
                                <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={AddExtraCharge} >Add extra charge</Button>
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("activeFrom")["isVisible"] && <div className="col-md-3">
                                <Field id={"activeFrom"} name={"activeFrom"} label={GetField("activeFrom")["label"]} component={FormDatePicker} onChange={ActiveFromChanged} />
                            </div>}
                            {GetField("activeTo")["isVisible"] && <div className='col-md-3'>
                                <Field id={"activeTo"} name={"activeTo"} label={GetField("activeTo")["label"]} component={FormDatePicker} onChange={ActiveToChanged } />
                            </div>}
                        </div>
                        </ExpansionPanel>}
                        {GetField("chargeDetails")["isVisible"] && <ExpansionPanel title={GetField("chargeDetails")["label"]} expanded={expandedPanels.chargeDetails} onToggle={() => togglePanel("chargeDetails")}>
                        <div className='row' >
                            {GetField("cartagePerTonne")["isVisible"] && <div className='col-md-3'>
                                <Field id={"cartagePerTonne"} name={"cartagePerTonne"} label={GetField("cartagePerTonne")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={CartagePerTonneChanged} />
                            </div>}
                            {GetField("minimumCartage")["isVisible"] && <div className='col-md-3'>
                                <Field id={"minimumCartage"} name={"minimumCartage"} label={GetField("minimumCartage")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={MinimumChargeChanged} />
                            </div>}
                            {GetField("cartageCostPerTonne")["isVisible"] && <div className='col-md-3'>
                                <Field id={"cartageCostPerTonne"} name={"cartageCostPerTonne"} label={GetField("cartageCostPerTonne")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={CartageCostPerTonneChanged } />
                            </div>}
                            {GetField("overloadFee")["isVisible"] && <div className='col-md-3'>
                                <Field id={"overloadFee"} name={"overloadFee"} label={GetField("overloadFee")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={OverloadFeeChanged} />
                            </div>}
                        </div>
                        </ExpansionPanel>}
                        {GetField("addressDetails")["isVisible"] && <ExpansionPanel title={GetField("addressDetails")["label"]} expanded={expandedPanels.addressDetails} onToggle={() => togglePanel("addressDetails")}>
                        <div className='row' >
                            {GetField("jobAddress1")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobAddress1"} name={"jobAddress1"} label={GetField("jobAddress1")["label"]} component={FormAddress} onChange={AddressChanged}  />
                            </div>}
                            {GetField("jobAddress2")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobAddress2"} name={"jobAddress2"} label={GetField("jobAddress2")["label"]} component={FormInput} onChange={JobAddress2Changed} />
                            </div>}
                            {GetField("jobSuburb")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobSuburb"} name={"jobSuburb"} label={GetField("jobSuburb")["label"]} component={FormInput} onChange={JobSuburbChanged} />
                            </div>}
                            {GetField("jobState")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobState"} name={"jobState"} label={GetField("jobState")["label"]} component={FormDropDownList} data={states} onChange={JobStateChanged} />
                            </div>}
                        </div>
                        <div className='row' >
                            {GetField("jobPostcode")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobPostcode"} name={"jobPostcode"} label={GetField("jobPostcode")["label"]} component={FormInput} onChange={JobPostcodeChanged} />
                            </div>}
                            {GetField("jobZone")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobZone"} name={"jobZone"} label={GetField("jobZone")["label"]} component={FormInput} onChange={JobZoneChanged} />
                            </div>}
                            {GetField("jobPhone")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobPhone"} name={"jobPhone"} label={GetField("jobPhone")["label"]} component={FormInput} onChange={JobPhoneChanged} />
                            </div>}
                            {GetField("jobEmail")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobEmail"} name={"jobEmail"} label={GetField("jobEmail")["label"]} component={FormInput} onChange={JobEmailChanged} />
                            </div>}
                        </div>
                        <div className='row' >
                            {GetField("showMap")["isVisible"] && <div className='col-md-3' style={{ paddingTop: "30px" }}>
                                <Button onClick={DisplayMap} >{GetField("showMap", "Show Map")["label"]}</Button>
                            </div>}
                        </div>
                        </ExpansionPanel>}
                        {GetField("linkedData")["isVisible"] && <ExpansionPanel title={GetField("linkedData")["label"]} expanded={expandedPanels.linkedData} onToggle={() => togglePanel("linkedData")}>
                        <div className='row' style={{ padding: "10px" }} >
                            {GetField("destinationId")["isVisible"] && <div className='col-md-4'>
                                {GetField("destinationId")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"destinationId"} data={destTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={DestinationsChanged} />                                
                            </div>}
                            {GetField("sourceId")["isVisible"] && <div className='col-md-4'>
                                {GetField("sourceId")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"sourceId"} data={sourcesTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SourcesChanged} />                                
                            </div>}
                            {GetField("jobTrucks")["isVisible"] && <div className='col-md-4'>
                                {GetField("jobTrucks")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"jobTrucks"} data={trucksTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={TrucksChanged} />
                            </div>}
                        </div>                                        
                        <div className='row' style={{ padding: "10px" }} >                           
                            {GetSession().SiteID && GetField("siteDetails")["isVisible"] && <div className='col-md-4'>
                                {GetField("siteDetails")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"jobSites"} data={sitesTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SitesChanged} />                                
                            </div>}
                        </div>
                        </ExpansionPanel>}
                        {GetField("productId")["isVisible"] && id !== undefined && <ExpansionPanel title={GetField("productId")["label"]} expanded={expandedPanels.productId} onToggle={() => togglePanel("productId")}>
                        <div className='row' style={{paddingBottom: "20px"}} >
                            {GetField("addProduct")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("addProduct")["label"]}</Label>
                                    <AutoComplete id={"addProduct"} name={"addProduct"} data={addProducts} value={addProduct} onChange={AddProductChanged} placeholder="Select Product" opened={addProductOpen} onFocus={OpenAddProduct} onBlur={() => { setAddProductOpen(false) }} />
                                </FieldWrapper>
                            </div>}
                            {GetField("addFree")["isVisible"] && <div className='col-md-2'>
                                <FieldWrapper>
                                    <Label>{GetField("addFree", "Price Type")["label"]}</Label>
                                    <Field component={FormDropDownList} id={"addFree"} name={"addFree"} onChange={AddFreeChanged} data={addFreeValues} />
                                </FieldWrapper>
                            </div>}
                            {GetField("addPrice")["isVisible"] && values.addFree === "Override Price" && <div className='col-md-2'>
                                <FieldWrapper>
                                    <Label>{GetField("addPrice")["label"]}</Label>
                                    <Field component={TextBox} id={"addPrice"} name={"addPrice"} type="number" min={0} max={100000} />
                                </FieldWrapper>
                            </div>}
                            {GetField("addTonnesOrdered")["isVisible"] && <div className='col-md-2'>
                                <FieldWrapper>
                                    <Label>{GetField("addTonnesOrdered")["label"]}</Label>
                                    <Field component={TextBox} id={"addTonnesOrdered"} name={"addTonnesOrdered"} type="number" min={0} max={100000} />
                                </FieldWrapper>
                            </div>}
                            <div className='col-md-1' style={{ paddingTop: "20px" }}>
                                <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" themeColor={"primary"} onClick={addProductClicked}>Add Product</Button>
                            </div>
                        </div>
                        <div className='row' >
                            {GetField("productId")["isVisible"] && <div>
                            <FieldWrapper>
                                <Field name="productGrid" dataItemKey={"id"} component={FormGrid} productList={jpp} jobId={id} update={UpdatePrices} />
                            </FieldWrapper>
                            </div>}
                        </div>          
                        </ExpansionPanel>}
                    </fieldset>
                    <div className="k-form-buttons" style={{paddingTop: 10}}>
                        <div className='col-md-1'>
                            <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={handleSubmit} disabled={submitDisabled}>{saveName}</Button>
                        </div>
                        <div className='col-md-1'>
                            <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={GoBack}>Cancel</Button>
                        </div>
                    </div>                
                </FormElement>
            )} />
            {showMap && <Dialog title="Address Map" onClose={() => setShowMap(false)}>
                <div style={{ width: "1000px" }}>
                    <Map center={centre} zoom={zoom} minZoom={5}>
                        <MapLayers>
                            <MapTileLayer urlTemplate={tileUrl} />
                            <MapMarkerLayer data={markers} locationField="position" titleField="name" />
                        </MapLayers>
                    </Map>
                </div>
            </Dialog>}
        </div>
    );
}

export default EditJobs